import { Box, ContentBlock, Text } from 'braid-design-system';

import { links } from 'src/links';

import { TextLink } from '../Link/Link';

export const NavAlertBanner = () => (
  <Box background="infoLight" paddingY="medium" paddingX="gutter">
    <ContentBlock width="large">
      <Box paddingX={['gutter', 'large']}>
        <Text>
          <span>Are you a Recruitment Software Provider? </span>
          <TextLink
            href={links.DEVELOPER_SITE.url}
            tracking={links.DEVELOPER_SITE.tracking}
          >
            Click here
          </TextLink>
          <span> to find out how you can work with SEEK.</span>
        </Text>
      </Box>
    </ContentBlock>
  </Box>
);
